import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgPhoneText = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M12.625 13.875V19.0983C12.625 19.7021 12.3851 20.2812 11.9582 20.7082C11.5312 21.1351 10.9521 21.375 10.3483 21.375H4.9025C4.29861 21.375 3.71945 21.1352 3.29236 20.7082C2.86527 20.2813 2.62522 19.7022 2.625 19.0983V6.1525C2.62522 5.54854 2.86524 4.96937 3.29231 4.54231C3.71937 4.11524 4.29854 3.87522 4.9025 3.875H7"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.625 17.625H12.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.875 2.625H12C11.337 2.625 10.7011 2.88839 10.2322 3.35723C9.76339 3.82607 9.5 4.46196 9.5 5.125V8.875C9.5 9.53804 9.76339 10.1739 10.2322 10.6428C10.7011 11.1116 11.337 11.375 12 11.375H15.125V14.5L18.25 11.375H18.875C19.538 11.375 20.1739 11.1116 20.6428 10.6428C21.1116 10.1739 21.375 9.53804 21.375 8.875V5.125C21.375 4.46196 21.1116 3.82607 20.6428 3.35723C20.1739 2.88839 19.538 2.625 18.875 2.625V2.625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.3125 6.6875C12.2507 6.6875 12.1903 6.70583 12.1389 6.74017C12.0875 6.7745 12.0474 6.82331 12.0238 6.88041C12.0001 6.93751 11.9939 7.00035 12.006 7.06097C12.0181 7.12158 12.0478 7.17727 12.0915 7.22097C12.1352 7.26467 12.1909 7.29444 12.2515 7.3065C12.3122 7.31855 12.375 7.31236 12.4321 7.28871C12.4892 7.26506 12.538 7.22501 12.5723 7.17362C12.6067 7.12223 12.625 7.06181 12.625 7C12.625 6.91712 12.5921 6.83763 12.5335 6.77903C12.4749 6.72042 12.3954 6.6875 12.3125 6.6875Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.4375 6.6875C15.3757 6.6875 15.3153 6.70583 15.2639 6.74017C15.2125 6.7745 15.1724 6.82331 15.1488 6.88041C15.1251 6.93751 15.1189 7.00035 15.131 7.06097C15.1431 7.12158 15.1728 7.17727 15.2165 7.22097C15.2602 7.26467 15.3159 7.29444 15.3765 7.3065C15.4372 7.31855 15.5 7.31236 15.5571 7.28871C15.6142 7.26506 15.663 7.22501 15.6973 7.17362C15.7317 7.12223 15.75 7.06181 15.75 7C15.75 6.91712 15.7171 6.83763 15.6585 6.77903C15.5999 6.72042 15.5204 6.6875 15.4375 6.6875Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5625 6.6875C18.5007 6.6875 18.4403 6.70583 18.3889 6.74017C18.3375 6.7745 18.2974 6.82331 18.2738 6.88041C18.2501 6.93751 18.2439 7.00035 18.256 7.06097C18.2681 7.12158 18.2978 7.17727 18.3415 7.22097C18.3852 7.26467 18.4409 7.29444 18.5015 7.3065C18.5622 7.31855 18.625 7.31236 18.6821 7.28871C18.7392 7.26506 18.788 7.22501 18.8223 7.17362C18.8567 7.12223 18.875 7.06181 18.875 7C18.875 6.91712 18.8421 6.83763 18.7835 6.77903C18.7249 6.72042 18.6454 6.6875 18.5625 6.6875Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgPhoneText.displayName = 'SvgPhoneText';
export default SvgPhoneText;
